import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { PPD_DUMP_NEW } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';

@Component({
  selector: 'app-ppd-dump-new',
  templateUrl: './ppd-dump-new.component.html',
  styleUrls: ['./ppd-dump-new.component.css']
})
export class PpdDumpNewComponent implements OnInit{
  constructor(private _requestService: RequestService, private _productStatus: ProductSatusService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectedStatus: string = '';
  productId: string = '';
  selectedBookType: string = '';
  selectedPPD: string = '';
  DefaultselectedPPD: string = 'current_month';
  selectedPublishedDate: string = '';
  selectedContractedDate: string = '';
  datesData: any = [];
  listStatus: any = [];
  listBookType: any = [];
  dropdownListStatus: any = [];
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  ngOnInit(): void {
    this.loadProductStatusList();
    this.loadProducts(this.createPostData());

    this.listBookType = ['Normal', 'Mini', 'Maxi', 'Licensed'];
  
    this.datesData = [
      'current_week',
      'last_week',
      'current_month',
      'last_month',
      'current_year',
      'last_year',
      'last_3_months',
      'last_6_months',
      'last_3_years',
    ];
  }

  loadProductStatusList() {
    return this._productStatus.getStatusList().subscribe((data: {}) => {
      this.listStatus = data;
      let statusList: any = [];
      this.listStatus.data.forEach(function (currentValue: any) {
        statusList.push(currentValue.attributes.name);
      });

      this.dropdownListStatus = statusList;
    });
  }

  loadProducts(
    postData: any = [],
    url: string = PPD_DUMP_NEW
  ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      status: this.selectedStatus,
      productId: this.productId,
      bookType: this.selectedBookType,
      ppd: this.selectedPPD,
      publishedDate: this.selectedPublishedDate,
      contractedDate: this.selectedContractedDate,
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      PPD_DUMP_NEW,
      {
        is_download: 1,
        status: this.selectedStatus,
        productId: this.productId,
        bookType: this.selectedBookType,
        ppd: this.selectedPPD,
        publishedDate: this.selectedPublishedDate,
        contractedDate: this.selectedContractedDate,
        page: this.currentPage,
      },
      '',
      'ppd_dump_new'
    );
  }

  updateSelectedType(event: any) {
    //console.log(event);

    if (event.name == 'status') {
      this.selectedStatus = event.selectedOption;
    }
    if (event.name == 'bookType') {
      this.selectedBookType = event.selectedOption;
    }
    if (event.name == 'ppd') {
      this.selectedPPD = event.selectedOption;
    }
    if (event.name == 'publishedDate') {
      this.selectedPublishedDate = event.selectedOption;
    }
    if (event.name == 'contractedDate') {
      this.selectedContractedDate = event.selectedOption;
    }
    // console.log(this.selectedStatus, this.dateModified);
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      status: this.selectedStatus,
      productId: this.productId,
      bookType: this.selectedBookType,
      ppd: this.selectedPPD,
      publishedDate: this.selectedPublishedDate,
      contractedDate: this.selectedContractedDate,
      page: this.currentPage,
    });

    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    (this.productId = ''),
    (this.selectedStatus = ''),
    (this.selectedBookType = ''),
    (this.selectedPPD = ''),
    (this.selectedPublishedDate = ''),
    (this.selectedContractedDate = ''),
    this.clearAllDropDowns();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }
}
